function useWebEngageGiveChanceClick() {
  const tracWebEngageGiveChanceClick = () => {
    try {
      window.webengage.track("give_chance_click");
    } catch (error) {
      console.log("🚀 ~ giveChanceClickWebEngage ~ error:", error);
    }
  };

  return { tracWebEngageGiveChanceClick };
}

export default useWebEngageGiveChanceClick;
